<script type="text/javascript">

    import { http } from '../../http';
    import axios from 'axios';
    import debounce from 'lodash/debounce';

    export default {

        data: function(){

            return {
                search_data : [],
                search_data_loaded : false,
                search_loading : false,
                search_focus: false,
                search_term: '',
                timeout : false,
                active_request_source: false,
                icons: {
                    client: "zmdi-accounts",
                    invoice: "zmdi-file-text",
                    creditnote: "zmdi-file-text",
                    event: "zmdi-calendar",
                    booking: "zmdi-calendar-alt",
                }
            }
        },
        props: {
            searchEndpoint: {
                required: false,
                default: '/app/search',
            }
        },
        mounted: function(){

            this.$nextTick(function() {
                $(document).ready(function(){
                    $(document).on("mouseenter", '#app .search-bar', function(){
                        $("#search-input").focus();
                    });
                    $(document).on("mouseleave", '#app .search-bar', function(){
                        $("#search-input").blur();
                    });
                    $(document).on("click", '#app .search-bar #search-form-mobile label', function(){
                        $(".search-item").addClass('search-active');
                        $("#search-form-mobile .search-mobile-input").focus();
                    });
                    $(document).on("click", '#app .search-bar #search-form-mobile .close-search', function(){
                        $(".search-item").removeClass('search-active');
                        $("#search-form-mobile .search-mobile-input").blur();
                    });
                });

                $(window).keydown (function(event) {
                    if (!(event.which == 115 && event.ctrlKey) && !(event.which == 19)) return true;
                    $("#search-input").focus();
                    event.preventDefault();
                    return false;
                });
            });

        },

        watch: {
            search_term : function(val, oldVal){
                if(val !== oldVal && val.length > 0){
                    this.getSearchData();
                }
            },
        },

        methods: {

            gotoNextSearchResult : function(direction){
                var elem = $(".search-results a.active");

                if(direction == "up"){
                    if(!elem.first().is(':first-child')){
                        $(".search-results a").removeClass("active");
                        elem.first().prev().addClass("active");
                    }
                }

                if(direction == "down"){
                    if(!elem.first().is(':last-child')){
                        $(".search-results a").removeClass("active");
                        elem.first().next().addClass("active");
                    }
                }


            },
            searchFieldBlur : function(){
                var vm = this;

                setTimeout(function(){
                    vm.search_focus = false;
                    vm.search_term = '';
                }, 300);

            },

            getSearchData : debounce(function(){
                this.search_loading = true;
                this.search_focus = true;

                if(this.active_request_source){
                    this.active_request_source.cancel('Operation canceled by the user.');
                }

                var CancelToken = axios.CancelToken;
                this.active_request_source = CancelToken.source();

                http.get(this.searchEndpoint, {
                    cancelToken: this.active_request_source.token,
                    params: {
                        search: this.search_term,
                    }
                })
                .then(({ data }) => {
                    this.search_loading = false;
                    this.search_data = data;
                    this.search_data_loaded = true;
                })
                .catch(() => {
                    this.search_loading = false;
                });

            }, 700),

            onSearchSubmit : function(){
                if(this.search_data.length > 0){
                    var url = $(".search-results a.active").first().attr("href");
                    if(url){
                        window.location = url;
                    }
                }
            }

        },
    };


</script>


<template id="search">
    <div class="global-search">
        <form role="search" class="navbar-left app-search pull-left" id="search-form" v-on:submit.prevent="onSearchSubmit">
            <nord-input
                :value="search_term"
                @input="event => search_term = event.target.value"
                hide-label
                autocomplete="off"
                v-on:blur="searchFieldBlur()"
                v-on:keyup.down="gotoNextSearchResult('down')"
                v-on:keyup.up="gotoNextSearchResult('up')"
                v-on:keyup.enter="onSearchSubmit()"
                :placeholder="trans('app.search')"
                class="global-search-input"
            >
                <i v-if="search_loading" slot="end" class="fa fa-spinner fa-spin"></i>
                <nord-icon name="navigation-search" slot="end" v-else></nord-icon>
            </nord-input>
            <div class="search-results" v-if="search_focus && search_data_loaded">
                <template v-if="search_data.length > 0">
                    <a :href="search_result.url" class="collection-item" :class="{ active: index === 0 }" v-for="(search_result, index) in search_data">
                        <div v-if="search_result.type == 'client'">
                            <span :style="{backgroundImage: 'url(' + search_result.meta.profile_image + ')'}" class="search-avatar m-r-10"></span>
                        </div>
                        <div v-else>
                            <i class="zmdi" :class="icons[search_result.type]"></i>
                        </div>
                        <div class="result">
                            <span class="search-label">{{ search_result.label }}</span>
                            <div v-if="search_result.type == 'invoice'" class="search-details">
                                <span class="search-detail">{{ search_result.meta.client_name }}</span>
                                <span class="search-detail"> - {{ $filters.humanize_date(search_result.meta.date.date) }}</span>
                            </div>
                            <div v-else-if="search_result.type === 'event'" class="search-details">
                                <span class="search-detail">{{ $filters.humanize_date(search_result.meta.date.date) }}</span>
                                <span class="search-detail"> - {{ search_result.meta.participants_label }}</span>
                            </div>
                        </div>
                    </a>
                </template>
                <a class="collection-item" v-if="search_data.length === 0 && search_term !== ''">{{ trans('app.no_results') }}</a>
            </div>

        </form>

    </div>
</template>
<style lang="scss" scoped>
    .global-search-input {
        --n-input-inline-size: 180px;
        --n-input-background: #fff;
    }
</style>
